<template>
  <PartialView>
    <ServiceCategories
      ref="categories"
      class="admin-content-partial"
      header-tag="h3"
      :id="categoryId"
      :route-params="{view: 'categories'}"
      :show-back="false"
      @update:categories="handleUpdateCategories"
      v-if="hasAdmin('SERVICE_CATEGORIES')"
    />

    <ServiceSubcategories
      ref="subcategories"
      class="admin-content-partial"
      :categories="categories"
      header-tag="h3"
      :id="subcategoryId"
      :route-params="{view: 'subcategories'}"
      :show-back="false"
      v-if="hasAdmin('SERVICE_SUBCATEGORIES')"
    />
  </PartialView>
</template>

<script>
import PartialView from "./PartialView";
import ServiceCategories from "./pages/ServiceCategories";
import ServiceSubcategories from "./pages/ServiceSubcategories";

export default {
  components: {
    PartialView,
    ServiceCategories,
    ServiceSubcategories,
  },

  data() {
    return {
      categoryId: this.view === "categories" ? this.id : undefined,
      categories: undefined,
      subcategoryId: this.view === "subcategories" ? this.id : undefined,
    };
  },

  props: {
    id: {
      type: [Number, String],
      default: undefined,
    },
    view: {
      type: String,
      default: "categories",
    },
  },

  methods: {
    handleUpdateCategories(categories) {
      this.categories = categories;
    },
    isDirty() {
      return false;
    },
  },

  mounted() {
    this.$refs.categories &&
      (this.$refs.categories.$el.id = "admin-service-categories");

    this.$refs.subcategories &&
      (this.$refs.subcategories.$el.id = "admin-service-subcategories");
  },

  beforeRouteUpdate(to, from, next) {
    to.params.view === "categories" &&
      (this.categoryId = +to.params.id || undefined);

    to.params.view === "subcategories" &&
      (this.subcategoryId = +to.params.id || undefined);

    this.abortRequests();
    next();
  },

  beforeRouteLeave(to, from, next) {
    if (
      !to.params.skipDirtyCheck &&
      Object.values(this.$refs).find((r) => r?.isDirty?.()) &&
      !this.confirmDiscard()
    ) {
      return next(false);
    }

    this.abortRequests();
    next();
  },
};
</script>